imaios.pubsub.subscribe(imaios.pubsub, 'analytics-set', ({key,value}) => {
    if (key === 'content_group' && value !== '') {
        const event = "group_content_view";
        let params = {
            content_group: value
        }
        sendEventToAnalytics(event, params);
    } else {
        sendSetToAnalytics(key, value);
    }
});
imaios.pubsub.subscribe(imaios.pubsub, 'analytics-search', ({searchTerm}) => {
    const event = "search";
    let params = {
        search_term: searchTerm
    }
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-view-item-list', ({itemListId, itemListName}) => {
    const event = "view_item_list";
    const items = document.querySelectorAll('.view-item-list');
    let addToItems = [];
    items.forEach(function(element) {
        let itemFormat = element.getAttribute('data-analytics-param-items');//.substring(1).slice(0,-1);
        addToItems.push(JSON.parse(itemFormat));
    });
    let params = {
        item_list_id: itemListId,
        item_list_name: itemListName,
        items: addToItems
    };
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-view-item', ({tab}) => {
    let items = document.querySelectorAll('.active.show .view-item-list');
    if (tab !== null) {
        items = document.querySelectorAll(tab +' .view-item-list');
    }
    const event = "view_item";

    items.forEach(function(element) {
        let itemFormat = element.getAttribute('data-analytics-param-items');
        let params = {
            currency: element.getAttribute('data-analytics-param-currency'),
            value: element.getAttribute('data-analytics-param-value'),
            items: JSON.parse(itemFormat)
        };
        sendEventToAnalytics(event, params);
    });

});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-begin-checkout', ({currency, value}) => {
    const event = "begin_checkout";
    const item = document.querySelector('div.begin-checkout').getAttribute('data-analytics-param-items');
    let itemToAdd = JSON.parse(item);
    itemToAdd.item_list_id = "begin_checkout_item";
    itemToAdd.item_list_name = "begin checkout item";
    let params = {
        currency: currency,
        value: value,
        items: [itemToAdd]
    };
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-add-shipping-info', ({currency, value}) => {
    const event = "add_shipping_info";
    const item = document.querySelector('div.begin-checkout').getAttribute('data-analytics-param-items');
    let params = {
        currency: currency,
        value: value,
        items: [JSON.parse(item)]
    };
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-add-payment-info', ({currency, value, paymentType}) => {
    const event = "add_payment_info";
    const item = document.querySelector('div.begin-checkout').getAttribute('data-analytics-param-items');
    let itemToAdd = JSON.parse(item);
    itemToAdd.item_list_id = "payment_method_form";
    itemToAdd.item_list_name = "payment method form";
    let params = {
        currency: currency,
        value: value,
        payment_type: paymentType,
        items: [itemToAdd]
    };
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'analytics-quicklinks', ({product, module, access}) => {
    const event = "module_open";
    let params = {
        placement: "quicklinks",
        product: product,
        module: module,
        access: access
    }
    sendEventToAnalytics(event, params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'cancel-renew', ({reason}) => {
    const event = "cancel_renew";
    let params = {
        reason: reason
    }
    sendEventToAnalytics(event, params);
});


imaios.pubsub.subscribe(imaios.pubsub, 'theme-switch', ({ theme, placement, individual_premium, ip_premium, group_premium }) => {
    let params = {
        placement,
        individual_premium,
        ip_premium,
        group_premium,
        target_name: "theme",
        target_value: theme,
        action: "switch_theme"
    }

    sendEventToAnalytics("user_action", params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'ga-anatomical-open-node', ({ nodeName }) => {
    let params = {
        target_name: nodeName,
        target_value: 'open',
    }

    sendEventToAnalytics("click", params);
});

imaios.pubsub.subscribe(imaios.pubsub, 'ga-anatomical-unfold-node', ({ nodeName }) => {
    let params = {
        target_name: nodeName,
        target_value: 'unfold',
    }

    sendEventToAnalytics("click", params);
});
